'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseboardHeaterIcon = function BaseboardHeaterIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '65',
                cy: '65',
                r: '65'
            }),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M25 87h79v22H25zM42 15h46v34H42z'
            }),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555',
                    fillRule: 'nonzero'
                },
                _react2.default.createElement('path', {
                    d: 'M63.425 34.052h2.078V16.386h-2.078zM60.223 34.14v-2.077H53.95v2.077z'
                }),
                _react2.default.createElement('path', {
                    d: 'M59.423 21.581v12.47H61.5V19.505H44.788v14.548h2.077v-12.47zM75.037 34.14v-2.077h-6.272v2.077z'
                }),
                _react2.default.createElement('path', {
                    d: 'M86.483 17.425v16.627h2.077V15.347H40.487v18.705h2.078V17.425z'
                }),
                _react2.default.createElement('path', {
                    d: 'M82.361 34.052h2.078V19.504H67.726v14.548h2.078v-12.47H82.36z'
                }),
                _react2.default.createElement(
                    'g',
                    null,
                    _react2.default.createElement('path', {
                        d: 'M63.425 31.676h2.078v17.666h-2.078zM59.423 44.146v-12.47H61.5v14.548H44.788V31.676h2.077v12.47z'
                    }),
                    _react2.default.createElement('path', {
                        d: 'M86.483 48.303V31.676h2.077v18.705H40.487V31.676h2.078v16.627z'
                    }),
                    _react2.default.createElement('path', {
                        d: 'M82.361 31.676h2.078v14.548H67.726V31.676h2.078v12.47H82.36z'
                    })
                )
            ),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555'
                },
                _react2.default.createElement('path', {
                    d: 'M15 110h100v-2H15zM15 115h100v-2H15z'
                })
            ),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555'
                },
                _react2.default.createElement('path', {
                    d: 'M23.103 85.456v23.32h2.115V87.543h78.747l-.023 21.232 2.117.003.024-23.322z'
                }),
                _react2.default.createElement('path', {
                    d: 'M32.47 97.61h64.245v-5.569H32.471v5.57zM30.356 99.7H98.83v-9.746H30.355v9.746z'
                }),
                _react2.default.createElement('path', {
                    d: 'M36.105 98.625h2.115v-7.6h-2.115zM43.82 98.625h2.115v-7.6H43.82zM51.535 98.625h2.115v-7.6h-2.115zM59.248 98.625h2.116v-7.6h-2.116zM66.963 98.625h2.116v-7.6h-2.116zM74.678 98.625h2.116v-7.6h-2.116zM82.392 98.625h2.115v-7.6h-2.115zM90.107 98.625h2.115v-7.6h-2.115zM31.228 105.399h63.643v-2.089H31.228zM97.228 105.399h1.643v-2.089h-1.643z'
                })
            )
        )
    );
};

BaseboardHeaterIcon.defaultProps = {
    width: '130',
    height: '130',
    viewBox: '0 0 130 130',
    xmlns: 'http://www.w3.org/2000/svg'
};

var BaseboardHeater = function (_React$Component) {
    _inherits(BaseboardHeater, _React$Component);

    function BaseboardHeater() {
        _classCallCheck(this, BaseboardHeater);

        return _possibleConstructorReturn(this, (BaseboardHeater.__proto__ || Object.getPrototypeOf(BaseboardHeater)).apply(this, arguments));
    }

    _createClass(BaseboardHeater, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || 'medium', this.props.type, this.props.screenSize);

            return _react2.default.createElement(BaseboardHeaterIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return BaseboardHeater;
}(_react2.default.Component);

exports.default = BaseboardHeater;